export default __webpack_public_path__ + "static/media/ml.d615db02.png";